import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Logo from '../../components/Logomenu';
import Icon from '../../design-system/icons/AppIcon';

const Brand = ({ asideStatus, setAsideStatus }) => {
	return (
		<div className='brand'>
			<div className='brand-logo'>
				<h1 className='brand-title'>
					<Link to='/' aria-label='SchedulerDesk home'>
						<Logo />
					</Link>
				</h1>
			</div>
			<button
				type='button'
				className='brand-panel-toggle'
				aria-label='Collapse side menu'
				onClick={() => setAsideStatus(!asideStatus)}>
				<Icon icon='VerticalSplit' />
			</button>
		</div>
	);
};
Brand.propTypes = {
	asideStatus: PropTypes.bool.isRequired,
	setAsideStatus: PropTypes.func.isRequired,
};

export default Brand;
